import styled from "styled-components";
import { useSelector } from "react-redux";

// import { Default } from "Types";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";

import AtomTitle from "Components/Atoms/Title";
import OrganismForm from "Components/Organisms/Form3";
import OrganismSteps from "Components/Organisms/Steps";
import AtomButton from "Components/Atoms/Button";

export type PropsType = any;

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;

const Form = styled(OrganismForm)`
   margin-top: 50px;
`;
const Button = styled(AtomButton)`
   margin-top: 35px;
`;
const Steps = styled(OrganismSteps)`
   margin-top: 45px;
`;

export default function TemplateStep3(props: PropsType) {
   const data = useSelector((state: any) => state.data);
   return (
      <Wrap>
         <AtomTitle>전시회 등록</AtomTitle>
         <Steps step={3}></Steps>
         <Form></Form>
         <Button onClick={props.nextOnClick} disabled={false && !data.files}>
            다음
         </Button>
      </Wrap>
   );
}
